import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import MedFrequencyForm from './MedFrequencyForm';

const EditMedFreqModal = ({ show, onHide, medfreqvalue, edittrigger, onCallParent }) => {
    const isEdit = Boolean(medfreqvalue && (medfreqvalue.frequency_id || medfreqvalue.freq_id || medfreqvalue.id));

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Frequency' : 'Add Frequency'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <MedFrequencyForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    medfreqvalue={medfreqvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

EditMedFreqModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    medfreqvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default EditMedFreqModal;
